import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "bridge-config"
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description my-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.description'))
    }
  }), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_vm.templateContext ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.otherStates,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.aggregationState'),
      "rules": _vm.requiredRule,
      "item-value": "key",
      "item-text": "properties.title",
      "autocomplete": "off",
      "disabled": _vm.mode === 'readonly',
      "no-filter": "",
      "hide-details": "",
      "data-cy": "select_timeAggr_state"
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('update');
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n              " + _vm._s(data.item.properties.title) + "\n            ")];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(data.item.properties.title) + "\n                ")]), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.key)
          }
        })], 1)];
      }
    }], null, false, 1460282697),
    model: {
      value: _vm.timeAggregation.bindedKey,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "bindedKey", $$v);
      },
      expression: "timeAggregation.bindedKey"
    }
  })], 1) : _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.otherStates,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.aggregationState'),
      "rules": _vm.requiredRule,
      "disabled": _vm.mode === 'readonly',
      "item-value": "id",
      "item-text": "properties.title",
      "hide-details": "",
      "data-cy": "select_timeAggr_state"
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('update');
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n              " + _vm._s(data.item.properties.title) + "\n              "), _c('span', [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")])];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(data.item.properties.title) + "\n                  "), _c('span', [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")])]), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.key)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.timeAggregation.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "stateId", $$v);
      },
      expression: "timeAggregation.stateId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.availableOperators,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.operation'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.mode === 'readonly',
      "rules": _vm.requiredRule,
      "hide-details": "",
      "data-cy": "select_timeAggr_operator"
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('update');
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [data.item.desc ? [_c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        }), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.desc)
          }
        })], 1)] : [_vm._v("\n                " + _vm._s(data.item.text) + "\n              ")]];
      }
    }]),
    model: {
      value: _vm.timeAggregation.operator,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "operator", $$v);
      },
      expression: "timeAggregation.operator"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('core-timezone-selector', {
    attrs: {
      "rules": _vm.requiredRule,
      "disabled": _vm.mode === 'readonly',
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.timeZone'),
      "required": "",
      "data-cy": "select_timeZone"
    },
    model: {
      value: _vm.timeAggregation.timeZone,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "timeZone", $$v);
      },
      expression: "timeAggregation.timeZone"
    }
  }), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.timeZoneDescription'))
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": [{
        value: 'Sunday',
        text: _vm.$i18n_t('Common.Sunday')
      }, {
        value: 'Monday',
        text: _vm.$i18n_t('Common.Monday')
      }],
      "color": _vm.color,
      "disabled": _vm.mode === 'readonly',
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.firstWeekDay'),
      "hide-details": "",
      "data-cy": "first_WeekDay"
    },
    model: {
      value: _vm.timeAggregation.firstWeekDay,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "firstWeekDay", $$v);
      },
      expression: "timeAggregation.firstWeekDay"
    }
  }), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.firstWeekDayDescription'))
    }
  })], 1)], 1), _vm.timeAggregation.operator !== 'latest_diff' ? _c('core-n20Card', {
    class: `dt-card-text-01 mt-0`,
    attrs: {
      "note": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.modeSimple')
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    class: _vm.timeAggregation.duration === undefined || _vm.availableDurations.findIndex(d => d.value === _vm.timeAggregation.duration) >= 0 ? 'required' : null,
    attrs: {
      "data-cy": "timeAggr_duration",
      "disabled": _vm.mode === 'readonly',
      "items": _vm.availableDurations,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.duration'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.timeAggregation.duration === undefined || _vm.availableDurations.findIndex(d => d.value === _vm.timeAggregation.duration) >= 0 ? _vm.requiredRule : [],
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        _vm.$emit('update');
        _vm.calcMomentStringComponents();
      }
    },
    model: {
      value: _vm.timeAggregation.duration,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "duration", $$v);
      },
      expression: "timeAggregation.duration"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSwitch, {
    staticClass: "mt-0 mb-2",
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.fixedTimestamp'),
      "color": _vm.color,
      "hide-details": "",
      "disabled": _vm.mode === 'readonly',
      "inset": ""
    },
    model: {
      value: _vm.timeAggregation.fixedTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.timeAggregation, "fixedTimestamp", $$v);
      },
      expression: "timeAggregation.fixedTimestamp"
    }
  }), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.fixedTimestampDesc'))
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.timeAggregation.operator !== 'latest_diff' && !_vm.timeAggregation.fixedTimestamp ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.or')))])], 1) : _vm._e(), _vm.timeAggregation.operator !== 'latest_diff' && !_vm.timeAggregation.fixedTimestamp ? _c('core-n20Card', {
    class: `dt-card-text-01 mt-0`,
    attrs: {
      "note": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.modeExpert')
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.expertModeText'))
    }
  }), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.mode === 'readonly',
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.offset'),
      "rules": _vm.requiredRule,
      "type": "number",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        _vm.calcMomentString();
        _vm.$emit('update');
      }
    },
    model: {
      value: _vm.offset,
      callback: function ($$v) {
        _vm.offset = _vm._n($$v);
      },
      expression: "offset"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "items": _vm.timeUnits,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.offsetUnit'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.mode === 'readonly',
      "rules": _vm.requiredRule,
      "hide-details": "",
      "data-cy": "offset_unit"
    },
    on: {
      "change": function ($event) {
        _vm.calcMomentString();
        _vm.$emit('update');
      }
    },
    model: {
      value: _vm.offsetUnit,
      callback: function ($$v) {
        _vm.offsetUnit = $$v;
      },
      expression: "offsetUnit"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.periodLength'),
      "rules": _vm.requiredRule,
      "disabled": _vm.mode === 'readonly',
      "type": "number",
      "hide-details": "",
      "data-cy": "period_length"
    },
    on: {
      "change": function ($event) {
        _vm.calcMomentString();
        _vm.$emit('update');
      }
    },
    model: {
      value: _vm.periodLength,
      callback: function ($$v) {
        _vm.periodLength = _vm._n($$v);
      },
      expression: "periodLength"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "items": _vm.timeUnits,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.periodUnit'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "disabled": _vm.mode === 'readonly',
      "hide-details": "",
      "data-cy": "period_unit"
    },
    on: {
      "change": function ($event) {
        _vm.calcMomentString();
        _vm.$emit('update');
      }
    },
    model: {
      value: _vm.periodUnit,
      callback: function ($$v) {
        _vm.periodUnit = $$v;
      },
      expression: "periodUnit"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };